export default __webpack_public_path__ + "images/liquality_151856.png";